import { IBrandInfo } from '../models';

const extractor = (
  pageHref: string,
  { name, createDate, updateDate, author }: Content.Article,
  { brandName, siteUrl, sameAs, schemaLogoFileName }: IBrandInfo
): object => {
  const url = new URL(pageHref);

  return {
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': pageHref,
    },
    headline: name,
    datePublished: createDate,
    dateModified: updateDate,
    author: {
      '@type': 'Person',
      name: author || brandName,
    },
    publisher: {
      '@type': 'Organization',
      name: brandName,
      url: siteUrl,
      sameAs,
      logo: {
        '@type': 'ImageObject',
        url: `${url.origin}/images/${schemaLogoFileName}`,
      },
    },
  };
};

export default extractor;
